/* eslint-disable camelcase */
// @TODO - wipe XGetElementById out of this class

class Display implements MerchantosDisplay {
  parts: MerchantosDisplayParts;

  display_recorded: boolean;

  constructor() {
    this.parts = {
      primary_nav: { node: null, display: null },
      section_nav: { node: null, display: null },
      listings_holder: { node: null, display: null },
      views_holder: { node: null, display: null },
      register_holder: { node: null, display: null },
      header: { node: null, display: null },
      react_page: { node: null, display: null },
    };
    this.display_recorded = false;
  }

  init = () => {
    this.parts.primary_nav.node = $('#drawer, .js-sidebar');
    this.parts.section_nav.node = $('#section');
    this.parts.listings_holder.node = $('#listing');
    this.parts.views_holder.node = $('#view');
    this.parts.register_holder.node = $('#register');
    this.parts.header.node = $('.js-topbar');
    this.parts.react_page.node = $('#react-page');
  };

  recordDisplay = () => {
    this.init();

    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    // eslint-disable-next-line
    $.each(this.parts, (_, part) => (part.display = part.node.css('display')));

    this.display_recorded = true;

    // also record keyboard keys
    window.merchantos.keyboard.store();
  };

  hideAll = () => {
    this.init();
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    $.each(this.parts, (_, part) => part.node.hide());
  };

  hide = (partName: string) => {
    this.init();
    $.each(this.parts, (i, part) => {
      if (i === partName) {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        part.node.hide();
      }
    });
  };

  lockScreen = () => $('body').addClass('need-verify-pin');

  unlockScreen = () => $('body').removeClass('need-verify-pin');

  hideListingsViews = () => {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    this.parts.listings_holder.node.hide();
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    this.parts.views_holder.node.hide();
  };

  resetAll = () => {
    this.init();

    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    $.each(this.parts, (_, part) => part.node.css('display', part.display));

    this.display_recorded = false;

    this.registerSearchFix();
    // restore keys for original content
    window.merchantos.keyboard.restore();
  };

  // If the page times out on a register search page,  these display objects
  // need to be fixed so that the display.resetAll function called by the
  // select buttons hides the sear listing and shows the regiser.
  registerSearchFix = () => {
    if (
      window.location.search.indexOf('item.listings.register_items') > -1 ||
      window.location.search.indexOf('item.listings.workorder_items') > -1
    ) {
      this.parts.listings_holder.display = 'none';
      this.parts.register_holder.display = 'block';
    }
  };

  // eslint-disable-next-line consistent-return
  addContent = (selector: string, html: string, options?: { skip_wrapper?: boolean }) => {
    let skip_wrapper = false;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if (options.skip_wrapper === true) {
      skip_wrapper = true;
    }

    // If the node already exists, otherwise use it.
    const node = $(`#${selector}`);
    if (node.length > 0) {
      node.html(html);
    } else {
      if (skip_wrapper) {
        $('#wrapper').append(html);
        return true;
      }
      $('#wrapper').append(
        $('<div>').attr('class', 'modal').attr('id', selector).htmlReplace(html)
      );
    }
  };

  replaceNonAjax = (html: string) => {
    this.init();
    // add register if missing
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    if (this.parts.register_holder.node.length <= 0) {
      this.parts.register_holder.node = $('<div id="register" data-test="register-wrapper"></div>');
      $('#wrapper').append(this.parts.register_holder.node);
    }
    this.hideListingsViews();
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    this.parts.section_nav.node.hide();
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    this.parts.register_holder.node.html(html).show();
  };

  showRegister = () => {
    this.init();
    // add register if missing
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    if (this.parts.register_holder.node.length <= 0) {
      this.parts.register_holder.node = $('<div id="register" data-test="register-wrapper"></div>');
      $('#wrapper').append(this.parts.register_holder.node);
    }
    this.hideListingsViews();
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    this.parts.section_nav.node.hide();
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    this.parts.register_holder.node.show();
  };

  toggle = (id: string) => $(`#${id}`).toggle();
}

window.merchantos.display = new Display();
